@if ((!entry || entry.base?.display) && fileDisplayArray.length) {
  <div class="upload-review-container">
    <h4 class="instructions-list-header">
      <strong>{{entry.custom?.reviewHeader ? entry.custom?.reviewHeader : 'Your Uploaded Files'}} </strong>
    </h4>
    <!-- TABLE DISPLAY -->
    <table>
      <!-- HEADER -->
      <thead>
        <tr>
        </tr>
      </thead>
      <!-- BODY -->
      <tbody>
        <!-- FILE LIST -->
        @for (displayableFileObj of fileDisplayArray; track displayableFileObj) {
          <tr>
            <!-- NAME -->
            <td>{{ (displayableFileObj.name.length > 50)? (displayableFileObj.name | slice:0:45) + '...':(displayableFileObj.name) }} &nbsp;&nbsp;&nbsp;</td>
            <!-- SIZE -->
            <td>{{ displayableFileObj.size | byteFormatter }}</td>
          </tr>
        }
      </tbody>
    </table>
    <br/>
    @if (!formConfig.form.customConfigs?.reviewOnly) {
      <button mat-raised-button
      class="edit-button" color="secondary" (click)="editQuestion(entry)">Edit</button>
    }
  </div>
}
